import { render, staticRenderFns } from "./AttrDetail.vue?vue&type=template&id=5c233e6a&"
import script from "./AttrDetail.vue?vue&type=script&lang=js&"
export * from "./AttrDetail.vue?vue&type=script&lang=js&"
import style0 from "./AttrDetail.vue?vue&type=style&index=0&id=5c233e6a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports